import React, {Component} from 'react';
import urlHandler   from '../../utils/urlHandler';
import SegmentUtils from '../../utils/segment-utils';
import GeoUtils from '../../utils/geoUtils';
import GeoMapMarker from '../../styles/images/marker-places.png';
import IPMapMarker from '../../styles/images/marker-computers.png';
import OrgMapMarker from '../../styles/images/marker-org.png';

/**
 * Thin wrapper over a Google Map.
 */

function latLong(result) {

	var entityAttrs = result.raw.entities[0].disambiguationResults[0].attributes;
	return [entityAttrs.latitude, entityAttrs.longitude];
}

class GoogleMap extends Component{
	constructor(props) {
		super(props);

        this.geoResults = this.geoResults.bind(this);
        this.getBoundsZoomLevel = this.getBoundsZoomLevel.bind(this);
        this.mapDisable = window._mapDisable;
	}

	geoResults() {

		var results = SegmentUtils.groupByType(this.props.results)['GEO'] || [];
		
		return SegmentUtils.uniqueBy(results, function(result) {
			return latLong(result).join('');
		});
	};

    /**
     * Determines best guess at the zoom level for the given Google bounds structure
     * @param {LatLng struct} bounds - Google bounds to determine zoom level for
     */
     getBoundsZoomLevel(bounds) {
        var WORLD_DIM = { height: 256, width: 256 };
        var mapDim = {height: 300, width: 300}
        var ZOOM_MAX = 21;
    
        function latRad(lat) {
            var sin = Math.sin(lat * Math.PI / 180);
            var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
            return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
        }
    
        function zoom(mapPx, worldPx, fraction) {
            return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
        }
    
        var ne = bounds.getNorthEast();
        var sw = bounds.getSouthWest();
    
        var latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;
    
        var lngDiff = ne.lng() - sw.lng();
        var lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;
    
        var latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction);
        var lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction);
    
        return Math.min(latZoom, lngZoom, ZOOM_MAX);
    }

	componentDidMount(){
        var self = this;

        if (this.mapDisable) return;

		if(this.props.results){
			google.setOnLoadCallback(() => {
						
                if(self.props.results){

                    var locations = self.props.results;
                    var points2 = []; 				
                    for( var i = 0; i<locations.length; i++){
                        
                        if(locations[i].entities[0].disambiguationResults !== undefined && 
                            locations[i].entities[0].disambiguationResults[0] !== undefined && 
                            locations[i].entities[0].disambiguationResults[0].attributes !== undefined && 
                            locations[i].entities[0].disambiguationResults[0].attributes.location !== undefined && 
                            locations[i].entities[0].disambiguationResults[0].attributes.location.longitude !== undefined && 
                            locations[i].entities[0].disambiguationResults[0].attributes.location.latitude !== undefined ) {
                            
                            var temp = [locations[i].entities[0].disambiguationResults[0].attributes.location.latitude,
                                locations[i].entities[0].disambiguationResults[0].attributes.location.longitude];
                            points2.push({
                                markerIcon: GeoMapMarker,
                                latlon: new google.maps.LatLng(temp[0],temp[1]),
                                title: locations[i].entities[0].normalizedText
                            });
                        } else if (locations[i].entities[0].attributes !== undefined &&
                            locations[i].entities[0].attributes.latitude !== undefined &&
                            locations[i].entities[0].attributes.longitude !== undefined && 
                            locations[i].entities[0].type === 'IPV4') {

                            var temp = [locations[i].entities[0].attributes.latitude,locations[i].entities[0].attributes.longitude];
                            points2.push({
                                markerIcon: IPMapMarker,
                                latlon: new google.maps.LatLng(temp[0],temp[1]),
                                title: locations[i].entities[0].normalizedText
                            });
                        } else if (locations[i].entities[0].attributes !== undefined &&
                            locations[i].entities[0].attributes.ipAddress !== undefined &&
                            locations[i].entities[0].attributes.ipAddress.latitude !== undefined &&
                            locations[i].entities[0].attributes.ipAddress.longitude !== undefined && 
                            locations[i].entities[0].type === 'URI') {

                            var temp = [locations[i].entities[0].attributes.ipAddress.latitude,locations[i].entities[0].attributes.ipAddress.longitude];
                            points2.push({
                                markerIcon: IPMapMarker,
                                latlon: new google.maps.LatLng(temp[0],temp[1]),
                                title: locations[i].entities[0].normalizedText
                            });
                        } else if (locations[i].entities[0].type.startsWith('ORGANIZATION') &&
                            locations[i].entities[0].disambiguationResults !== undefined &&
                            locations[i].entities[0].disambiguationResults[0] !== undefined) 
                        {
                            //If we run across an ORG, we need to make an /entities request on the associated id as 
                            //the location information for ORGs is not available from the /enrich response.
                            //
                            if (locations[i].entities[0].disambiguationResults[0].id) {
                                urlHandler.sendRequest('entities2', null, locations[i].entities[0].disambiguationResults[0].id, null, null, (response,txt,status) => {
                                    if (status == 200) {
                                        if (response.location !== undefined) {
                                            if (response.location.latitude !== undefined && response.location.longitude !== undefined) {
                                                var temp = [response.location.latitude,response.location.longitude];
        
                                                points2.push({
                                                    markerIcon: OrgMapMarker,
                                                    latlon: new google.maps.LatLng(temp[0],temp[1]),
                                                    title: response.label
                                                });
                                            }
                                        }
                                    }
                                });
                            }
                        }
                    }
    
                    var latLng = new google.maps.LatLng(37.763108,-122.455799);
                    
                    var mapOptions = {
                        zoom: 9,
                        center: latLng,
                        disableDefaultUI: true,
                        zoomControl: 'zoomControl' in this.props ? this.props.zoomControl : true,
                        //scaleControl: true,
                    };
                    var gmap = new google.maps.Map(self.refs.gmap, mapOptions);

                    var bounds = new google.maps.LatLngBounds();
                    for(var j=0; j<points2.length; j++){
                        var marker = new google.maps.Marker({
                            position: points2[j].latlon,
                            icon: {
                                url: points2[j].markerIcon
                            },
                            opacity: 0.85,
                            title: points2[j].title,
                            map: gmap
                        });

                        bounds.extend(marker.getPosition());
                        gmap.setCenter(bounds.getCenter());
                        
                    }

                    google.maps.event.addListenerOnce(gmap, 'bounds_changed', function(event) {
                        gmap.setZoom(gmap.getZoom());

                        if (gmap.getZoom() > 15) {
                            gmap.setZoom(15);
                        }
                    });

                    gmap.addListener('marker_add_evt', function(marker) {
                        bounds.extend(new google.maps.LatLng(marker[0],marker[1]));
                        gmap.fitBounds(bounds);
                    });

                    gmap.fitBounds(bounds);

                }			
            })
		}
		
		if(this.props.lng != undefined && this.props.lat != undefined){

			var markerIcon = GeoMapMarker;
			if (this.props.type && (this.props.type == 'IPV4' || this.props.type == 'URI')) {
				markerIcon = IPMapMarker;
			}
			else if (this.props.type && this.props.type.startsWith('ORGANIZATION')) {
				markerIcon = OrgMapMarker;
			} 

			google.setOnLoadCallback(() => {

                var latLng = new google.maps.LatLng(self.props.lat, self.props.lng);
                
                var mapOptions = {
                    zoom: 8,
                    center: latLng,
                    disableDefaultUI: true,
                    zoomControl: 'zoomControl' in this.props ? this.props.zoomControl : true,
                    //scaleControl: true,
                };

                if (!self.refs.gmap) {
                    return;
                }
                
                var gmap = new google.maps.Map(self.refs.gmap, mapOptions);
                var bounds = new google.maps.LatLngBounds();
                if (self.props.boundingBox) {
                    if (GeoUtils.isPointInBoundingBox(self.props.lat, self.props.lng, self.props.boundingBox)) {
                        var southWest = new google.maps.LatLng(self.props.boundingBox.minLatitude, self.props.boundingBox.minLongitude);
                        var northEast = new google.maps.LatLng(self.props.boundingBox.maxLatitude, self.props.boundingBox.maxLongitude);
                        bounds = new google.maps.LatLngBounds(southWest,northEast);
                        
                        var zoom = this.getBoundsZoomLevel(bounds);
                        gmap.setZoom(zoom);
                    }
                }

                var marker = new google.maps.Marker({
                    position: latLng,
                    map: gmap,
                    icon: {
                        url: markerIcon
                    },
                    opacity: 0.85,
                    title: self.props.label
                });

                google.maps.event.addListenerOnce(gmap, 'bounds_changed', function(event) {
                    gmap.setZoom(gmap.getZoom());
                    if (gmap.getZoom() > 15) {
                        gmap.setZoom(15);
                    }
                });
                
                google.maps.event.trigger(gmap, 'resize');
            })
		} // if lat and long specifically 
	}

	render() {
		return (
			<div className='map-container' style={this.props.style} hidden = {this.props.hidden} >
				<div ref='gmap' style={this.props.style} className='map-inner-container'>
                    <div className="map-loading">
                        <span className="fa fa-circle-o-notch fa-spin"></span>&nbsp;&nbsp;Loading map ...
                    </div>
				</div>
			</div>
		);
	}
};

export default GoogleMap;